/**
 * Абстрактный базовый класс для моделей справочников<para/>
 * Abstract base class for handbooks models
 */
export class BaseHandbook {
    /**
     * Первичный ключ<para/>
     * Primary key
     */
    Id: number = 0;
    /**
     * Наименование на русском языке<para/>
     * Name in russian
     */
    NameRu: string = '';
    /**
     * Наименование на казахском языке<para/>
     * Name in kazakh
     */
    NameKz: string = '';
    /**
     * Наименование на английском языке<para/>
     * Name in english
     */
    NameEn: string = '';
    /**
     * Признак возможности редактирования<para/>
     * Sign of editing availability
     */
    isEditable: boolean = false;
}